// ConfirmDeleteDialog.tsx
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Button } from "Atoms";

interface Props {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  /** Optional: name of the thing being deleted */
  itemName?: string;
  /** Optional: custom title/description/labels */
  title?: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Optional: disable buttons / show loading state while deleting */
  loading?: boolean;
}

export default function ConfirmDeleteDialog({
  open,
  onCancel,
  onConfirm,
  itemName,
  title = "Delete Item",
  description = "Are you sure you want to delete this item? This action cannot be undone.",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  loading = false,
}: Props) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <WarningAmberRoundedIcon color="error" />
        {title}
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2">
          {description}
        </Typography>
        {itemName && (
          <Typography variant="subtitle2" sx={{ mt: 1.5 }}>
            Item: <b>{itemName}</b>
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button variant="outlined" onClick={onCancel} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={loading}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
